export default {
  en: 'English',
  // <-- English on the top as default -->
  af: 'Afrikaans',
  ar: 'العربية',
  az: 'Azeri',
  bg: 'Български',
  bn: 'বাংলা',
  bs: 'Bosanski',
  ca: 'Català',
  cs: 'Čeština',
  da: 'Dansk',
  de: 'Deutsch',
  el: 'Ελληνικά',
  'en-AU': 'English (Australia)',
  'en-GB': 'English (UK)',
  es: 'Español',
  'es-AR': 'Español (Argentina)',
  'es-ES': 'Español (España)',
  et: 'Eesti keel',
  eu: 'Euskera',
  fi: 'Suomi',
  fr: 'Français (France)',
  'fr-CA': 'Français (Canada)',
  gl: 'Galego',
  he: 'עברית',
  hi: 'हिन्दी',
  hr: 'Hrvatski',
  hu: 'Magyar',
  id: 'Bahasa Indonesia',
  it: 'Italiano',
  ja: '日本語',
  ka: 'ქართული ენა',
  kk: 'қазақ тілі',
  km: 'ខ្មែរ',
  ko: '한국어',
  // lo: 'ພາສາລາວ',
  lt: 'Lietuvių',
  lv: 'Latviešu',
  mk: 'Македонски',
  ms: 'Bahasa Melayu',
  // my: 'မြန်မာဘာသာ',
  nb: 'Norsk (bokmål)',
  nl: 'Nederlands',
  pl: 'Polski',
  pt: 'Português (Brasil)',
  'pt-PT': 'Português (Portugal)',
  ro: 'Română',
  ru: 'Русский',
  sk: 'Slovenčina',
  sl: 'Slovenščina',
  // sq: 'Shqip',
  sr: 'Srpski',
  sv: 'Svenska',
  // sw: 'Kiswahili',
  ta: 'தமிழ்',
  te: 'తెలుగు',
  th: 'ภาษาไทย',
  tl: 'Filipino',
  tr: 'Türkçe',
  uk: 'Українська',
  vi: 'Tiếng Việt',
  'zh-Hans': '中文 (简体)',
  'zh-Hant': '中文 (台灣)',
};

// https://lingohub.com/academy/glossary/right-to-left-language
export const rltLanguages: Set<string> = new Set([
  'ar',
  'dv',
  'fa',
  'ha',
  'he',
  'ks',
  'ku',
  'ps',
  'ur',
  'yi',
]);
